(ns ncr.sidebar.labels
  (:require
   [ncr.widgets.core :as w]
   [ncr.etc.util :as u]
   [ncr.navigate :as n]
   [ncr.nsql :as nsql]
   [ncr.sidebar.common :as common]
   [ncr.etc.pf :as pf]))

(defn c-label [{:keys [pinned? on-pin-click] :as props} {:keys [href label] :as folder}]
  [common/c-sidebar-item
   (merge props
     {:href href
      :entry folder
      :class (if pinned? :ncr-c-nav-list--label__pinned :ncr-c-nav-list--label__unpinned)})
   [pf/c-split
    [pf/c-split-item {:is-filled true} label]
    [pf/c-split-item
     [w/c-toolbar-button
      {:icon :pin :on-click (u/isolate* on-pin-click)}]]]])

(defn model [labels]
  (->> labels
    (sort-by :name)
    (map
      (fn [{:keys [id name]}]
        (let [query (str "label:" (nsql/maybe-quote name))]
          {:id id :label (str "#" name) :drop-accepted? false :href (n/search-href query) :query query})))))
